import React from 'react';
import "./index.css";
import { formatPrice } from '../../../../utils/func';
import { useLocation } from 'react-router-dom';

const CartSummary = ({ payDetailInfo, markupDetails }) => {

  const location = useLocation()

  const ticketFee = payDetailInfo?.ticket_fee;
  const subTotal = payDetailInfo?.total?.sub_total;
  const currency = payDetailInfo?.total?.currency;
  const markupPercentage = markupDetails?.markup_percentage
  const checkForCheckoutPage = location.pathname === "/checkout"
  const priceMarkup = markupDetails?.price_markup
  const isToShowPriceWithMarkup = Boolean(markupDetails?.price_markup && markupDetails?.price_markup > 0 && checkForCheckoutPage)


  console.log(isToShowPriceWithMarkup, "isToShowPriceWithMarkup")

  return (
    <div className="cart-summary">
      <div className="summary-item">
        <span>Subtotal</span>
        <span>{subTotal ? `${currency} ${formatPrice(subTotal)}` : 'N/A'}</span>
      </div>
      {ticketFee && (
        <div className="summary-item">
          <span>Including Vat</span>
          <div className='ticket_fess_summary'>
            <span>{`${currency} ${formatPrice(ticketFee.sub_total)}`}</span>
          </div>
        </div>
      )}

      {
        isToShowPriceWithMarkup ?
          <>
            <div className="summary-item">
              <span>Order total</span>
              <div className='ticket_fess_summary'>
                <span>{subTotal ? `${currency} ${formatPrice(subTotal)}` : 'N/A'}</span>
              </div>
            </div>
            <div className="summary-item total">
              <span><strong>New Price Added</strong></span>
              <span><strong>{isToShowPriceWithMarkup ? `${currency} ${formatPrice(subTotal, isToShowPriceWithMarkup, markupPercentage)}` : 'N/A'}</strong></span>
            </div>
          </>
          :
          <div className="summary-item total">
            <span><strong>Order total</strong></span>
            <span><strong>{subTotal ? `${currency} ${formatPrice(subTotal)}` : 'N/A'}</strong></span>
          </div>

      }
    </div>
  );
};

export default React.memo(CartSummary);
